<!--
    描述：详细分析首页
    时间：2020-07-28
    Created by ws
-->
<template>
	<w-split v-model="splitV"
			 class="analysis-detail-main">
		<!-- 左侧结构树 -->
		<left-structure slot="left"
						:editable="false"
						:showCheckbox="true"
						ref="leftTree"
						@rowClick="leftRowClick"
						@onCheck="checkChange"></left-structure>

		<!-- 右侧表格 -->
		<div class="w-strucutre-layout"
			 slot="right">
			<div class="w-strucutre-header">
				<div class="btnGroups">
					<el-tooltip effect="light" popper-class="help-content" append-to-body>
						<div slot="content">
							<p>
								1. 先在项目结构页面，维护本项目结构。
							</p>
							<p>
								2. 在造价文件页面，导入控制价。
							</p>
							<p>
								3. 勾选左侧项目结构单位工程（左侧勾选哪一个单位工程，则对该单位工程量进行清单一致性检查)。
							</p>
							<p>
								4. 选择前者一个基准值，后者一个对比值，进行清单检查分析。
							</p>
							<p>
								5. 分析后可点击“导出Excel”导出。也可点击“手动分析”设置分析规则后，再导出分析报告。
							</p>
						</div>
						<span class="help-title"
						><i class="el-icon-question"></i> 帮助说明</span
						>
					</el-tooltip>
					<el-button size="small" icon="el-icon-data-line" type="primary" @click="autoAnalysis"
					>自动分析
					</el-button>
					<el-button size="small" icon="el-icon-data-line" type="primary" plain @click="openRule"
					>手动分析
					</el-button>
					<el-button
							size="small"
							icon="el-icon-menu"
							:type="showAllData ? 'danger' : 'success'"
							@click="changeTableType"
					>{{ showAllData ? "异常清单" : "全部清单" }}
					</el-button>
					<el-button size="small"
							   icon="el-icon-menu"
							   type="primary"
							   @click="doFilter">列过滤
					</el-button>
					<el-button size="small"
							   icon="el-icon-refresh"
							   type="warning"
							   @click="doReset">重置
					</el-button>
					<el-button plain
							   size="small"
							   type="primary"
							   icon="el-icon-download"
							   @click="doExport(0)">导出Excel
					</el-button>
					<el-button size="small"
							   icon="el-icon-upload"
							   v-if="roleBtns.includes('detail-Html')"
							   @click="doExport(1)">导出Html
					</el-button>
				</div>
			</div>
			<div class="w-structure-content"
				 v-loading="sheetLoading">
				<detail-table ref="detailTable" :searchForm="exportObj"
							  @onSuccess="changeSelect"></detail-table>
			</div>

			<!-- 弹窗信息 -->
			<el-dialog :title="dialogObj.title"
					   :visible.sync="dialogObj.visible"
					   :width="dialogObj.width"
					   :close-on-click-modal="false"
					   @closed="handleClose">
				<!-- 列过滤 -->
				<div class="text-center h100 overflow-hidden"
					 v-if="dialogObj.type === 'filter'">
					<!-- 对比列筛选 -->
					<el-row class="check-row">
						<el-col :span="4"
								class="check-name text-overflow">{{ getColumnName(1) }}
							<el-checkbox class="ml10"
										 @change="handleAllChange($event, 'compareArr1')"
										 v-model="checkAll.compare1">全选</el-checkbox>
						</el-col>
						<el-col :span="20"
								class="check-content">
							<el-checkbox-group v-model="compareArr1">
								<el-checkbox v-for="(item, index) in compareFilter"
											 :label="item.key"
											 :key="'对比列1' + index">{{ item.label }}</el-checkbox>
							</el-checkbox-group>
						</el-col>
					</el-row>
					<el-row class="check-row">
						<el-col :span="4"
								class="check-name text-overflow">{{ getColumnName(2) }}
							<el-checkbox class="ml10"
										 @change="handleAllChange($event, 'compareArr2')"
										 v-model="checkAll.compare2">全选</el-checkbox>
						</el-col>
						<el-col :span="20"
								class="check-content">
							<el-checkbox-group v-model="compareArr2">
								<el-checkbox v-for="(item, index) in compareFilter"
											 :label="item.key"
											 :key="'对比列2' + index">{{ item.label }}</el-checkbox>
							</el-checkbox-group>
						</el-col>
					</el-row>
					<!-- 增减量筛选 -->
					<el-row class="check-row">
						<el-col :span="4"
								class="check-name">增减量
							<el-checkbox class="ml10"
										 @change="handleAllChange($event, 'amountArr')"
										 v-model="checkAll.amount">全选</el-checkbox>
						</el-col>
						<el-col :span="20"
								class="check-content">
							<el-checkbox-group v-model="amountArr">
								<el-checkbox v-for="(item, index) in amountFilter"
											 :label="item.key"
											 :key="'增减量' + index">{{ item.label }}</el-checkbox>
							</el-checkbox-group>
						</el-col>
					</el-row>
					<!-- 增减幅度筛选 -->
					<el-row class="check-row">
						<el-col :span="4"
								class="check-name">增减幅度
							<el-checkbox class="ml10"
										 @change="handleAllChange($event, 'rateArr')"
										 v-model="checkAll.rate">全选</el-checkbox>
						</el-col>
						<el-col :span="20"
								class="check-content">
							<el-checkbox-group v-model="rateArr">
								<el-checkbox v-for="(item, index) in rateFilter"
											 :label="item.key"
											 :key="'增减幅度' + index">{{ item.label }}</el-checkbox>
							</el-checkbox-group>
						</el-col>
					</el-row>
				</div>

				<!-- 显示数据范围 -->
				<div class="text-center h100 overflow-hidden"
					 v-if="dialogObj.type === 'edit'">
					<div class="range-header">
						<span>选择默认模板： </span>
						<el-select v-model="defaultRange"
								   @change="onRangeChange"
								   size="small">
							<el-option v-for="(item, index) in defaultRangeList"
									   :key="'默认模板' + index"
									   :label="item.sname"
									   :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="range-header">
						<el-radio-group v-model="rangeObj.type">
							<el-radio label="addup">合价</el-radio>
							<el-radio label="rateCost">单价</el-radio>
							<el-radio label="quantity">工程量</el-radio>
						</el-radio-group>
					</div>
					<!-- 合计Input -->
					<div class="range-content"
						 v-if="rangeObj.type === 'addup'">
						<p class="range-row">
							<span class="range-row-name">增加值大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.addup.amount">
									<template slot="append">元</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">增幅大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.addup.rate">
									<template slot="append">%</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">同时满足：</span>
							<span class="range-row-input">
								<el-switch v-model="rangeObj.addup.isSupport"
										   active-text="是"
										   inactive-text="否">
								</el-switch>
							</span>
						</p>
					</div>
					<!-- 单价 input -->
					<div class="range-content"
						 v-if="rangeObj.type === 'rateCost'">
						<p class="range-row">
							<span class="range-row-name">增加值大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.rateCost.amount">
									<template slot="append">元</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">增幅大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.rateCost.rate">
									<template slot="append">%</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">同时满足：</span>
							<span class="range-row-input">
								<el-switch v-model="rangeObj.rateCost.isSupport"
										   active-text="是"
										   inactive-text="否">
								</el-switch>
							</span>
						</p>
					</div>
					<!-- 工程量 input -->
					<div class="range-content"
						 v-if="rangeObj.type === 'quantity'">
						<p class="range-row">
							<span class="range-row-name">增加值大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.quantity.amount">
									<template slot="append">元</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">增幅大于：</span>
							<span class="range-row-input">
								<el-input type="number"
										  v-model="rangeObj.quantity.rate">
									<template slot="append">%</template>
								</el-input>
							</span>
						</p>
						<p class="range-row">
							<span class="range-row-name">同时满足：</span>
							<span class="range-row-input">
								<el-switch v-model="rangeObj.quantity.isSupport"
										   active-text="是"
										   inactive-text="否">
								</el-switch>
							</span>
						</p>
					</div>
				</div>

				<div slot="footer"
					 class="dialog-footer text-center">
					<el-button @click="dialogObj.visible = false"
							   size="small">取 消
					</el-button>
					<el-button type="primary"
							   size="small"
							   :loading="btnLoading"
							   @click="doConfirm">确 定
					</el-button>
				</div>
			</el-dialog>

			<!-- 规则弹窗 -->
			<el-dialog
					:visible.sync="ruleDialog.visible"
					:title="ruleDialog.title"
					:width="ruleDialog.width"
					:close-on-click-modal="false"
					@closed="handleRuleClose"
			>
				<!-- 第二步 打开具体规则 -->
				<template v-if="ruleDialog.step === 2">
					<rule-table ref="ruleTable" :mode="ruleDialog.mode"  :isSys="isSys" needSave></rule-table>
				</template>

				<!-- footer 组件 -->
				<div
						slot="footer"
						class="dialog-footer text-center"
				>
					<el-button size="small" @click="ruleDialog.visible = false"
					>取 消</el-button
					>
					<el-button
							type="primary"
							size="small"
							:loading="ruleDialog.btnLoading"
							@click="onRuleConfirm"
					>确 定</el-button
					>
				</div>
			</el-dialog>
		</div>
	</w-split>
</template>

<script>
	// 组件
	import leftStructure from '@/views/project-management/project-info/components/left_structure'
	import detailTable from './detail_table_new'
	import ruleTable from "@/views/basic-template/rule-setting/rule_table.vue";

	// js
	import { mapState } from 'vuex'
	import { exportExcel, dateFormat } from '@/utils/tools'
	import { getRulesList } from "@/api/modules/clearSection.js";
	import {getCodesAndNames} from '@/api/modules/analysisInventory'
	export default {
		components: {
			leftStructure,
			detailTable,
			ruleTable
		},
		data() {
			return {
				splitV: 0.3,
				sheetLoading: false, // 列表等待状态
				resData: {}, // 新动态返回的数据
				tableData: [],
				showAllData: true, // 是否展示全部清单数据
				// 弹窗对象
				dialogObj: {
					title: '添加对比',
					visible: false,
					width: '90%',
					type: 'filter',
					exportExcel: false
				},
				curName: '', // 当前点击的 结构树层级名称
				btnLoading: false,
				checkAll: {
					compare1: false,
					compare2: false,
					amount: true,
					rate: true
				},
				// 对比筛选数据
				compareFilter: [
					{
						label: '清单特征',
						key: 'projectFeatures'
					},
					{
						label: '计量单位',
						key: 'unit'
					},
					{
						label: '工程量',
						key: 'quantity'
					},
					{
						label: '单价',
						key: 'rateCost'
					},
					{
						label: '合价',
						key: 'addup'
					}
				],
				compareArr1: ['unit', 'quantity', 'rateCost', 'addup'], // 最终筛选的 对比数组1
				compareArr2: ['unit', 'quantity', 'rateCost', 'addup'], // 最终筛选的 对比数组2
				// 增减量筛选数据
				amountFilter: [
					{
						label: '工程量',
						key: 'quantity'
					},
					{
						label: '单价',
						key: 'rateCost'
					},
					{
						label: '合价',
						key: 'addup'
					}
				],
				amountArr: ['quantity', 'rateCost', 'addup'], // 最终筛选的 增减量数组
				// 增减幅度筛选数据
				rateFilter: [
					{
						label: '工程量',
						key: 'quantity'
					},
					{
						label: '单价',
						key: 'rateCost'
					},
					{
						label: '合价',
						key: 'addup'
					}
				],
				rateArr: ['quantity', 'rateCost', 'addup'], // 最终筛选的 增减幅度数组
				// 显示数据范围
				rangeObj: {
					type: 'addup',
					quantity: {
						amount: '', // 增加量
						rate: '', // 增减幅度
						isSupport: true // 是否同时满足
					},
					rateCost: {
						amount: '', // 增加量
						rate: '', // 增减幅度
						isSupport: true // 是否同时满足
					},
					addup: {
						amount: '', // 增加量
						rate: '', // 增减幅度
						isSupport: true // 是否同时满足
					}
				},
				// 默认 数据范围模板值
				defaultRange: '',
				// 默认  数据范围模板列表
				defaultRangeList: [],
				// 导出、查询 参数对象
				exportObj: {
					projectId: '', // 项目ID
					busProContractTreeId: '', // 项目结构树id
					type1: '',	// 第一个类型
					type2: '',	// 第二个类型
					phase1: '',	// 第1个造价阶段
					phase2: '',	// 第2个造价阶段
					analysisType: '0',	// 初始传0， 手动传0， 自动传1
					rules: {},	// 规则
					phases: '', // 造价阶段
					phaseName: '', // 造价阶段中文
					rangeType: 1, // 范围类型( 合计--1 ， 单价---2， 工程量---3)
					rangeAmount: '', // 增加量
					rangeRate: '', // 增幅度
					both: 1, // 都满足 还是 满足其中任一都可以 (2 是交集-同时满足, 1 是并集-任一满足)
					userName: 'xxx',
					treeIds: []
				},
				// 规则弹窗相关
				ruleDialog: {
					title: "手动分析",
					visible: false,
					width: "1200px",
					mode: "edit",
					step: 0,
					btnLoading: false,
				},
				pageLoading: null,
				rulesList: [],
				curRule: {},
				isSys: '2'
			}
		},
		created() {
			// 获取规则
			this.getRules()
		},
		methods: {
			// 左侧项目结构树点击事件
			leftRowClick(row) {
				// 项目名称 以及  当前层级名称
				let _pname = this.projectName
				let _name = row.sname

				this.exportObj.busProContractTreeId = row.id
				// 第一级
				if (row.levelType === 0) {
					this.curName = _name
				} else if (row.levelType === 1) {
					this.curName = _pname + ' | ' + _name
				} else {
					let _dname = this.$refs.leftTree.tableData[0].children.find(
							x => x.id === row.pid
					).sname
					this.curName = _pname + ' | ' + _dname + ' | ' + _name
				}
			},

			// 左侧树复选框选择事件
			checkChange(arr) {
				if (this.$refs.detailTable) {
					this.exportObj.treeIds = arr
					let params = this.setParams()
					// 清空分析条件
					params.analysisType = '0'
					params.rules = {}
					// this.$refs.detailTable.getTableData(params)
					this.loadDetailTable(params)
					// 获取名称和 编码数组
					this.getCodeTypeList(params)
				}
			},

			// 加载表格
			loadDetailTable(params) {
				if (this.$refs.detailTable) {
					// 请求参数
					this.$refs.detailTable.queryParams = this.$utils.clone(params, true)

					this.$refs.detailTable.loadData()
				}
			},

			// 获取全部生效的规则
			getRules() {
				getRulesList({})
						.then((res) => {
							this.rulesList = res.data;
						})
						.catch((err) => {
							this.rulesList = [];
						});
			},

			// m弹窗关闭事件
			handleClose() {
				this.dialogObj.visible = false
				this.btnLoading = false
			},

			// 弹窗按钮确认事件
			doConfirm() {
				this.btnLoading = true;
				// 列过滤
				if (this.dialogObj.type === 'filter') {
					this.$refs.detailTable.compareArr1 = this.compareArr1;
					this.$refs.detailTable.compareArr2 = this.compareArr2;
					this.$refs.detailTable.amountArr = this.amountArr;
					this.$refs.detailTable.rateArr = this.rateArr;
					setTimeout(() => {
						this.$refs.detailTable.resizeTable()
					}, 300)
				} else {
					let params = this.setParams()
					this.$refs.detailTable.getTableData(params)
				}
				this.handleClose();
			},

			// 列过滤全选事件
			handleAllChange(status, type) {
				let list = []
				switch (type) {
					case 'amountArr':
						list = ['quantity', 'rateCost', 'addup']
						break
					case 'rateArr':
						list = ['quantity', 'rateCost', 'addup']
						break
					default:
						list = [
							'projectFeatures',
							'unit',
							'quantity',
							'rateCost',
							'addup'
						]
				}

				if (status) {
					this[type] = list
				} else {
					this[type] = []
				}
			},

			// 请求传值参数设置
			setParams() {
				// 项目ID
				this.exportObj.projectId = this.curProjectId
				this.exportObj.phase1 = this.$refs.detailTable.priceType1
				this.exportObj.phase2 = this.$refs.detailTable.priceType2
				this.exportObj.type1 = this.$refs.detailTable.getPhaseObj.type1
				this.exportObj.type2 = this.$refs.detailTable.getPhaseObj.type2
				// this.exportObj.phases =
				// 	this.$refs.detailTable.priceType1 +
				// 	',' +
				// 	this.$refs.detailTable.priceType2
				let phaseName = this.$refs.detailTable.getPhaseObj.nameStr
				this.exportObj.phaseName = phaseName

				this.exportObj.rangeType = this.rangeObj.type
				this.exportObj.rangeAmount = this.rangeObj[
						this.rangeObj.type
						].amount
				this.exportObj.rangeRate = this.rangeObj[this.rangeObj.type].rate
				this.exportObj.both = this.rangeObj[this.rangeObj.type].isSupport
						? '2'
						: '1'
				this.exportObj.userName = this.userName
				this.exportObj.phase = this.$refs.detailTable.priceType1
				this.exportObj.type = this.$refs.detailTable.getPhaseObj.type1
				return this.exportObj
			},

			// 列过滤名称
			getColumnName(type) {
				if (this.$refs.detailTable) {
					// let params = this.$refs.detailTable.getColumnName()
					// return type === 1 ? params.column1 : params.column2
				}
				return ''
			},

			// 点击列过滤按钮
			doFilter() {
				if (this.$refs.detailTable) {
					this.$refs.detailTable.openFilter()
				}
			},

			// 切换表格展示（全部清单、异常清单）
			changeTableType() {
				this.showAllData = !this.showAllData;
				this.$refs.detailTable ? this.$refs.detailTable.changeData(this.showAllData) : ''
			},

			// 点击重置按钮
			doReset() {
				// 过滤列重置
				// this.compareArr1 = ['unit', 'quantity', 'rateCost', 'addup']
				// this.compareArr2 = ['unit', 'quantity', 'rateCost', 'addup']
				// this.amountArr = ['quantity', 'rateCost', 'addup']
				// this.rateArr = ['quantity', 'rateCost', 'addup']

				// // 表格重置
				
				// 清除全部条件 （排序、筛选）
				if (this.$refs.detailTable) {
					this.$refs.detailTable.clearAll()
				}

				// 清除列过滤


				// 如果是处在分析状态
				if (this.exportObj.rules.totalPrice || this.exportObj.analysisType === '1') {
					this.exportObj.analysisType = '0'
					this.exportObj.rules = {}
					let params = this.setParams()

					// 重置时清空规则
					this.curRule = {}

					this.loadDetailTable(params)
				}

				// // 重新调整表格高度
				// setTimeout(() => {
				// 	this.$refs.detailTable.resizeTable()
				// }, 300)
			},

			// 显示数据范围
			doRange() {
				this.dialogObj.title = '显示数据范围'
				this.dialogObj.type = 'edit'
				this.dialogObj.visible = true
			},

			// 点击导出 （0 是excel, 1 是html）
			doExport(type) {
				if (
						this.$refs.detailTable &&
						this.$refs.detailTable.getListData().length === 0
				) {
					this.$message.info('暂时没有要导出的数据！')
					return
				}

				// loading
				this.pageLoading =  this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
				})

				let saveName =
						'详细分析列表数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
				let params = this.setParams()
				params.label = type
				params.saveName = saveName
				// params.list = this.$refs.detailTable?.allTableData || []
				params.list = this.$refs.detailTable?.getListData() || []
				params.rules = this.curRule?.rules || {}
				params.ruleName = this.curRule?.sname || ''

				exportExcel(
						// 'busDetailedAnalysisAppraisal/exportDetailExcelByCondition',
						'labor/exportLaborData',
						params,
						saveName
				).then((data) => {
					// loading
					this.pageLoading.close()
				}).catch(err => {
					// loading
					this.pageLoading.close()
				})
			},

			// 默认范围模板切换事件
			onRangeChange(val) {
				// console.log(val)
				let _item = this.defaultRangeList.find(x => x.value === val)
				switch (val) {
						// 默认合价模板
					case '1001002':
						this.setDefaultValue(_item, 'addup')
						break
						// 默认单价模板
					case '1001004':
						this.setDefaultValue(_item, 'rateCost')
						break
						// 默认工程量模板
					case '1001006':
						this.setDefaultValue(_item, 'quantity')
						break
					default:
						break
				}
			},

			// 设置值
			setDefaultValue(item, type) {
				this.rangeObj.type = type
				this.rangeObj[type].amount = item.rangeAmount
						? String(item.rangeAmount)
						: ''
				this.rangeObj[type].rate = item.rangeRate
						? String(item.rangeRate)
						: ''
				this.rangeObj[type].isSupport =
						parseInt(item.meanwhileMeet) === 1 ? false : true
			},

			/* --------------- 规则弹窗模块 ------------------- */
			// 自动分析
			autoAnalysis() {
				// 保存 当前规则 (系统默认规则)
				let _default = this.rulesList.find((x) => x.isDefault === 1);
				if (_default) {
					this.curRule = _default
				}

				let params = this.setParams();
				params.analysisType = '1';
				this.loadDetailTable(params);
				this.showAllData = true;
			},

			// 打开规则弹窗（手动分析）
			openRule() {
				this.ruleDialog.mode = 'edit';
				this.ruleDialog.step = 2;
				this.ruleDialog.width = "1200px";
				this.ruleDialog.visible = true;
			},

			// 规则弹窗确认
			onRuleConfirm() {
				let params = this.setParams();
				if (this.$refs.ruleTable) {
					// 保存当前规则（导出用）
					this.curRule = this.$refs.ruleTable.ruleObj
					this.curRule.rules = this.$utils.clone(this.$refs.ruleTable.rules, true);

					// 更新保存一次规则
					params.rules = this.$utils.clone(this.$refs.ruleTable.rules, true);
					params.analysisType = '3';
					this.ruleDialog.visible = false
					this.loadDetailTable(params)
					this.showAllData = true;
				}
			},

			// 规则弹窗关闭
			handleRuleClose() {
				this.ruleDialog.step = 0;
			},

			changeSelect(){
				this.showAllData = true;
			},

			// 获取编码分类数组
			getCodeTypeList(params) {
				getCodesAndNames(params)
						.then(res => {
							if (this.$refs.detailTable) {
								// 清单名称过滤数组
								this.$refs.detailTable.filterObj.nameList =
										res.data.billNames

								// 清单编码数组
								let _list = this.$utils.toArrayTree(
										res.data.billCodes,
										{ parentKey: 'pid' }
								)
								// 删除多余的 children 空数组
								this.$utils.eachTree(_list, item => {
									if (item.children && item.children.length === 0) {
										delete item.children
									}
								})
								this.$refs.detailTable.filterObj.codeList = _list

								// 单位数组
								this.$refs.detailTable.filterObj.unitList =
										res.data.billUnits
							}
						})
						.catch(err => {})
			},
		},
		computed: {
			// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
			curSource() {
				return this.$route.query.source || '0'
			},
			// 项目名称
			projectName() {
				return this.$route.query.projectName
			},

			// 项目ID
			curProjectId() {
				return this.$route.query.projectId
			},
			...mapState('menu', {
				roleBtns: state => state.roleBtns
			}),
			// 用户名称
			...mapState('user', {
				userName: state => state.userInfo.sname
			})
		},
		watch: {
			compareArr1(arr) {
				if (arr.length === this.compareFilter.length) {
					this.checkAll.compare1 = true
				} else {
					this.checkAll.compare1 = false
				}
			},
			compareArr2(arr) {
				if (arr.length === this.compareFilter.length) {
					this.checkAll.compare2 = true
				} else {
					this.checkAll.compare2 = false
				}
			},
			amountArr(arr) {
				if (arr.length === this.amountFilter.length) {
					this.checkAll.amount = true
				} else {
					this.checkAll.amount = false
				}
			},
			rateArr(arr) {
				if (arr.length === this.rateFilter.length) {
					this.checkAll.rate = true
				} else {
					this.checkAll.rate = false
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.analysis-detail-main {
		.check-row {
			margin-bottom: 7px;
			background-color: #a3e3ff;
			height: 35px;
			line-height: 35px;
			font-weight: 700;
			color: #333;
			.check-name {
				border-right: 1px solid #1d7f8a;
			}

			.check-content {
				text-align: left;
				padding-left: 15px;
			}
		}

		.check-row:nth-of-type(2) {
			background-color: #f5f5ad;
		}

		.check-row:nth-of-type(3) {
			background-color: #ffe4c4;
		}

		.check-row:nth-of-type(4) {
			background-color: #7fffd4;
		}

		.range-header {
			text-align: left;
			padding-left: 10px;
			height: 35px;
			line-height: 35px;
		}

		.range-content {
			padding: 10px;
			.range-row {
				display: flex;
				height: 40px;
				line-height: 40px;
				margin-bottom: 10px;
			}
			.range-row-name {
				display: flex;
				align-items: center;
				width: 100px;
			}
			.range-row-input {
				flex: 1;
				text-align: left;
			}
		}

		.help-title {
			color: #409eff;
			font-size: 14px;
			display: inline-block;
			line-height: 32px;
			margin: 0 15px;
			cursor: pointer;
		}
	}
</style>